'use client';

import { replacePlaceholder } from '@/helpers/cms';
import { currentFullYear } from '@/helpers/dateTime';
import { useContentByLicense } from '@/modules/license/hooks/useContentByLicense';
import { useGetCommonStore } from '@/store';
import { ScFooterCopyright } from './styled';

const FooterCopyright = () => {
  const useCommonStore = useGetCommonStore();
  const cmsConfig = useCommonStore.use.cmsConfig();

  const text = useContentByLicense(cmsConfig?.copyrightByLicense);

  if (!text) return null;

  return (
    <ScFooterCopyright
      dangerouslySetInnerHTML={{
        __html: replacePlaceholder(text, 'year', String(currentFullYear)),
      }}
    />
  );
};

export default FooterCopyright;
